import React, { useState, useEffect } from 'react';

import { Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import ServiceService from 'Services/ServiceService';
import { Link } from 'react-router-dom';

const Apps = (props) => {
    const history = useHistory();
    const {
        match: { params },
    } = props;
    const [service, setService] = useState(null);

    useEffect(() => {
        if (params.serviceId) {
            ServiceService.getServiceById(params.serviceId)
                .then((result) => {
                    if (result.status === 200) {
                        setService(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const onDelete = () => {
        ServiceService.deleteService(service)
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/service/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin/service/index' }}>
                    Services
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Delete</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">Delete Service</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{service && service.nom}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6 d-flex flex-column align-items-center">
                    <img src="/images/alert.svg" alt="" style={{ width: '100pt' }} className="d-block" />
                    <h4 className="py-3">Irreversible Action</h4>
                    <button className="btn btn-danger" onClick={onDelete}>
                        Delete {service && service.nom}
                    </button>
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default Apps;
